import style from './style.css?url'
import grid from '~/styles/components/grid.css?url'

/**
 * Leveraged by `_content._product.*` routes
 */
export const links = () => [
  { rel: 'stylesheet', href: style },
  { rel: 'stylesheet', href: grid },
]
